import { render, staticRenderFns } from "./before-after-license-agreement-modal.vue?vue&type=template&id=45ff5d70"
import script from "./before-after-license-agreement-modal.vue?vue&type=script&lang=ts"
export * from "./before-after-license-agreement-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports